import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Spinner,
} from "reactstrap";
import NibbleInput from "../../../components/Fields/NibbleInput";
import { uploadFile } from "../../../helpers/backend_helper";
import * as _ from "lodash";
import { ToastHelper } from "../../../helpers/alerts/alertHelper";

const FILE_URL = process.env.REACT_APP_BACKEND_API_URL + "/files";

const VehicleFiles = ({
  selected = {},
  validation,
  isOnlyRead = false,
  title = "Archivos del vehículo",
}) => {
  const [isUploadingFile, setIsUploadingFile] = useState({});

  useEffect(() => {
    const selectedByKey = _.keyBy(selected, "name");

    const newFiles = {
      ...validation.values.files,
      ...selectedByKey,
    };

    validation.setFieldValue("files", newFiles);
  }, []);

  const onUploadFile = ({ file, name }) => {
    if (!file) return;

    const body = {
      file,
      file_tag: name,
      file_type: "Instalacion",
    };

    setIsUploadingFile((prev) => ({ ...prev, [name]: true }));
    uploadFile(body)
      .then((resp) => responseFileAction(name, resp))
      .finally(() => {
        setIsUploadingFile((prev) => ({ ...prev, [name]: false }));
      });
  };

  const responseFileAction = (name, response) => {
    if (response.status) {
      const { id } = response.file;

      const currentFileIds = validation.values.files[name].fileIds || [];
      const updatedFilesIds = [...currentFileIds, id];

      validation.setFieldValue(`files.${name}.fileIds`, updatedFilesIds);

      return;
    }

    const { message = "", error = "" } = response;

    ToastHelper(`${message}: ${error}`, "error");
  };

  const onDeleteFile = ({ name, fileId }) => {
    const currentFileIds = validation.values.files[name].fileIds || [];
    const updatedFilesIds = currentFileIds.filter((id) => id !== fileId);

    validation.setFieldValue(`files.${name}.fileIds`, updatedFilesIds);
  };

  console.log({ values: validation.values });

  return (
    <Card className="my-4 installation">
      <CardHeader>
        <h5 className="m-0">{title}</h5>
      </CardHeader>
      <CardBody>
        <Row>
          {Object.values(validation.values.files).map(
            ({ name, fileType, fileIds = [] }) => {
              const successFile = (
                <>
                  {fileType} <i className="text-success fas fa-check"></i>
                </>
              );
              const fileTypeName = fileIds.length ? successFile : fileType;
              const isUploading = isUploadingFile[name];

              return (
                <div key={name}>
                  <div className="row border-bottom border-light py-2">
                    {isOnlyRead ? (
                      <Col md={9} className="d-flex align-items-center">
                        <label className="mb-0">{fileTypeName}</label>
                      </Col>
                    ) : (
                      <NibbleInput
                        md={9}
                        label={fileTypeName}
                        fieldName={name}
                        fieldType="file"
                        validation={{ handleChange: onUploadFile }}
                        fileAccept="image/*;capture=camera"
                        readOnly={isUploading}
                      />
                    )}
                    <Col
                      md={3}
                      className="mt-2 text-center d-flex justify-content-center"
                    >
                      {isUploading && <FileSpinner />}
                    </Col>
                    <Col md={12}>
                      <div className="d-flex flex-wrap pt-2">
                        {fileIds.map((id) => (
                          <VehicleFile
                            key={id}
                            id={id}
                            name={name}
                            fileType={fileType}
                            isOnlyRead={isOnlyRead}
                            onDeleteFile={onDeleteFile}
                          />
                        ))}
                      </div>
                    </Col>
                  </div>
                  {isOnlyRead && <hr />}
                </div>
              );
            }
          )}
        </Row>
      </CardBody>
    </Card>
  );
};

const FileSpinner = () => (
  <div className="d-flex justify-content-center align-items-center pr-2">
    <Spinner size="sm" />
  </div>
);

const VehicleFile = ({ id, name, fileType, isOnlyRead, onDeleteFile }) => (
  <div
    className="d-flex flex-column justify-content-between"
    style={{ paddingRight: "10px" }}
  >
    <a
      title={fileType}
      href={`${FILE_URL}/${id}`}
      target="_blank"
      rel="noreferrer"
      download
      className="d-block mb-2 text-center"
    >
      <img
        alt={name}
        src={`${FILE_URL}/${id}`}
        className="d-inline-block"
        style={{ maxWidth: "100px", maxHeight: "70px" }}
      />
    </a>
    {!isOnlyRead && (
      <div className="text-center">
        <Button
          color="primary"
          size="sm"
          title="Eliminar fotografía seleccionada"
          onClick={() => onDeleteFile({ name, fileId: id })}
        >
          <i className="fa fa-times"></i> Eliminar
        </Button>
      </div>
    )}
  </div>
);

export default VehicleFiles;
